import React, { useEffect, useState } from "react";
import AdminSideBar from "./AdminSideBar";
import { useSelector } from "react-redux";
import { Col, Row, Tab } from "react-bootstrap";
import axios from "axios";
import { Spinner } from "react-bootstrap";
function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const user = useSelector((state) => state.user_auth);
  useEffect(() => {
    const ordersURL = process.env.REACT_APP_API_URL + `/admin/orders`;

    const fetchOrdersData = async () => {
      const ordersData = await axios({
        method: "GET",
        url: ordersURL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      setOrders(ordersData.data);
    };
    fetchOrdersData();
  }, []);

  return (
    <div id="twc-admin">
      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="fourth">
          <Row className="mt-6 mb-5">
            <Col sm={2} className="d-flex flex-column">
              <AdminSideBar />
            </Col>
            <Col sm={10}>
              <Tab.Content>
                <Tab.Pane eventKey="fourth">
                  <div className="shadow p-4 border border-dark rounded admin-table">
                    {orders.length !== 0 ? (
                      <table className="table table-light table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Username</th>
                            <th scope="col">Email</th>
                            <th scope="col">Dirección</th>
                            <th scope="col">Teléfono</th>
                            <th scope="col">Productos</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orders.map((order) => (
                            <tr key={order._id}>
                              <th scope="row">{order.firstName + " " + order.lastName}</th>
                              <td>{order.email}</td>
                              <td>{order.address}</td>
                              <td>{String(order.phone)}</td>
                              <td>
                                {order.products.map((product) => (
                                  <div key={product._id} className="d-flex flex-column text-start">
                                    {product.name}
                                  </div>
                                ))}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="d-flex justify-content-center text-center align-items-center">
                        <Spinner animation="border" role="status"></Spinner>
                        <span className="ms-1">Loading...</span>
                      </div>
                    )}
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </div>
    </div>
  );
}

export default AdminOrders;
